import { useEffect } from 'react';

const s = {
  page: { fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', backgroundColor: '#fff', color: '#1a1a1a', minHeight: '100vh' },
  nav: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 48px', borderBottom: '0.5px solid #e8e8e8', backgroundColor: '#fff' },
  navLogo: { fontSize: '17px', fontWeight: '700', letterSpacing: '-0.4px', color: '#1a1a1a', textDecoration: 'none' },
  navLinks: { display: 'flex', alignItems: 'center', gap: '8px' },
  btnAdmin: { padding: '8px 16px', background: 'none', border: 'none', fontSize: '12px', color: '#aaa', cursor: 'pointer', letterSpacing: '0.3px', textDecoration: 'none' },
  btnGhost: { padding: '8px 16px', background: 'none', border: '0.5px solid #e0e0e0', borderRadius: '6px', fontSize: '13px', color: '#444', cursor: 'pointer', textDecoration: 'none', display: 'inline-block' },
  btnDark: { padding: '8px 16px', background: '#1a1a1a', border: 'none', borderRadius: '6px', fontSize: '13px', color: '#fff', cursor: 'pointer', textDecoration: 'none', display: 'inline-block' },
  hero: { padding: '96px 48px 80px', textAlign: 'center', maxWidth: '720px', margin: '0 auto' },
  heroH1: { fontSize: '52px', fontWeight: '800', letterSpacing: '-2px', color: '#1a1a1a', lineHeight: 1.05, marginBottom: '20px' },
  heroP: { fontSize: '17px', color: '#666', lineHeight: 1.6, marginBottom: '36px', maxWidth: '480px', marginLeft: 'auto', marginRight: 'auto' },
  heroBtns: { display: 'flex', gap: '12px', justifyContent: 'center', marginBottom: '20px' },
  btnPrimary: { padding: '14px 28px', background: '#1a1a1a', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', textDecoration: 'none', display: 'inline-block' },
  btnOutline: { padding: '14px 28px', background: '#fff', color: '#1a1a1a', border: '0.5px solid #ccc', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', textDecoration: 'none', display: 'inline-block' },
  heroNote: { fontSize: '12px', color: '#bbb' },
  preview: { background: '#f7f5f0', borderRadius: '12px', margin: '0 48px 80px', padding: '32px', border: '0.5px solid #e8e8e8' },
  previewBar: { display: 'flex', gap: '6px', marginBottom: '20px' },
  previewDot: { width: '10px', height: '10px', borderRadius: '50%', background: '#e0ddd8' },
  previewInner: { background: '#fff', borderRadius: '8px', border: '0.5px solid #e8e8e8', padding: '20px', display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '20px', minHeight: '160px' },
  previewSidebar: { display: 'flex', flexDirection: 'column', gap: '8px' },
  previewMenuItem: { padding: '8px 12px', background: '#f5f5f3', borderRadius: '6px', fontSize: '12px', color: '#666' },
  previewMenuItemActive: { padding: '8px 12px', background: '#1a1a1a', borderRadius: '6px', fontSize: '12px', color: '#fff' },
  previewContent: { display: 'flex', flexDirection: 'column', gap: '10px' },
  previewRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '0.5px solid #f0f0f0' },
  previewName: { fontSize: '13px', fontWeight: '500', color: '#1a1a1a' },
  previewPrice: { fontSize: '13px', fontWeight: '700', color: '#1a1a1a' },
  features: { padding: '0 48px 80px' },
  featuresLabel: { fontSize: '11px', fontWeight: '600', letterSpacing: '2px', textTransform: 'uppercase', color: '#aaa', textAlign: 'center', marginBottom: '48px' },
  featuresGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' },
  featureCard: { padding: '24px', border: '0.5px solid #e8e8e8', borderRadius: '10px', background: '#fff' },
  featureIcon: { width: '36px', height: '36px', background: '#f5f5f3', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '14px', fontSize: '16px' },
  featureTitle: { fontSize: '14px', fontWeight: '600', color: '#1a1a1a', marginBottom: '6px' },
  featureDesc: { fontSize: '12px', color: '#888', lineHeight: 1.6 },
  cta: { margin: '0 48px 80px', background: '#1a1a1a', borderRadius: '12px', padding: '56px 48px', textAlign: 'center' },
  ctaH2: { fontSize: '32px', fontWeight: '800', color: '#fff', letterSpacing: '-0.8px', marginBottom: '12px' },
  ctaP: { fontSize: '15px', color: 'rgba(255,255,255,0.6)', marginBottom: '28px' },
  btnWhite: { padding: '14px 28px', background: '#fff', color: '#1a1a1a', border: '2px solid #fff', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', textDecoration: 'none', display: 'inline-block' },
  footer: { padding: '24px 48px', borderTop: '0.5px solid #e8e8e8', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  footerCopy: { fontSize: '12px', color: '#bbb' },
  footerLinks: { display: 'flex', gap: '20px' },
  footerLink: { fontSize: '12px', color: '#bbb', textDecoration: 'none' },
};

const features = [
  { icon: 'QR', title: 'QR code ready', desc: 'Generate a QR code for your menu instantly. Print it and place it on every table.' },
  { icon: 'ED', title: 'Easy to update', desc: 'Change prices, add items, or mark items as sold out in seconds from your dashboard.' },
  { icon: 'ST', title: 'Staff access', desc: 'Give your staff a PIN login to manage item availability on the floor.' },
  { icon: 'MN', title: 'Multiple menus', desc: 'Create separate menus for breakfast, lunch, dinner, or special occasions.' },
  { icon: 'FP', title: 'Food photography', desc: 'Upload photos for each item so customers can see exactly what they are ordering.' },
  { icon: 'BR', title: 'Your brand', desc: 'Add your logo, cover image, and brand colour to make the menu feel like yours.' },
];

function Landing() {
  useEffect(() => {
    document.title = 'Menu Board';
  }, []);

  return (
    <div style={s.page}>
      <nav style={s.nav}>
        <a href="/" style={s.navLogo}>Menu Board</a>
        <div style={s.navLinks}>
          <a href="/admin" style={s.btnAdmin}>Admin</a>
          <a href="/login" style={s.btnGhost}>Sign in</a>
          <a href="/register" style={s.btnDark}>Get started</a>
        </div>
      </nav>

      <div style={s.hero}>
        <h1 style={s.heroH1}>Your digital menu,<br />online in minutes</h1>
        <p style={s.heroP}>Create a beautiful digital menu for your restaurant. Share it via QR code, WhatsApp, or a link. No technical skills needed.</p>
        <div style={s.heroBtns}>
          <a href="/register" style={s.btnPrimary}>Create your menu</a>
          <a href="/login" style={s.btnOutline}>Sign in</a>
        </div>
        <p style={s.heroNote}>Free to get started. No credit card required.</p>
      </div>

      <div style={s.preview}>
        <div style={s.previewBar}>
          <div style={s.previewDot}></div>
          <div style={s.previewDot}></div>
          <div style={s.previewDot}></div>
        </div>
        <div style={s.previewInner}>
          <div style={s.previewSidebar}>
            <div style={s.previewMenuItemActive}>Beverages</div>
            <div style={s.previewMenuItem}>Mains</div>
            <div style={s.previewMenuItem}>Sides</div>
            <div style={s.previewMenuItem}>Desserts</div>
          </div>
          <div style={s.previewContent}>
            <div style={s.previewRow}><span style={s.previewName}>Zobo Drink</span><span style={s.previewPrice}>N800</span></div>
            <div style={s.previewRow}><span style={s.previewName}>Chapman</span><span style={s.previewPrice}>N1,200</span></div>
            <div style={s.previewRow}><span style={s.previewName}>Kunu</span><span style={s.previewPrice}>N600</span></div>
            <div style={s.previewRow}><span style={s.previewName}>Fanta</span><span style={s.previewPrice}>N500</span></div>
          </div>
        </div>
      </div>

      <div style={s.features}>
        <p style={s.featuresLabel}>Everything you need</p>
        <div style={s.featuresGrid}>
          {features.map(function(f, i) {
            return (
              <div key={i} style={s.featureCard}>
                <div style={s.featureIcon}>{f.icon}</div>
                <div style={s.featureTitle}>{f.title}</div>
                <div style={s.featureDesc}>{f.desc}</div>
              </div>
            );
          })}
        </div>
      </div>

      <div style={s.cta}>
        <h2 style={s.ctaH2}>Ready to go digital?</h2>
        <p style={s.ctaP}>Join restaurants already using Menu Board.</p>
        <a href="/register" style={s.btnWhite}>Create your free menu</a>
      </div>

      <div style={s.footer}>
        <span style={s.footerCopy}>2026 Menu Board</span>
        <div style={s.footerLinks}>
          <a href="/privacy" style={s.footerLink}>Privacy Policy</a>
          <a href="mailto:contact@menuboard.ng" style={s.footerLink}>Contact</a>
          <a href="/admin" style={s.footerLink}>Admin login</a>
        </div>
      </div>
    </div>
  );
}

export default Landing;
